<script setup>
import { onMounted, onUnmounted } from "vue";
import { trackScrollDepth } from "./composables/useAnalytics";

let stopScrollDepth;

onMounted(() => {
  stopScrollDepth = trackScrollDepth();
});

onUnmounted(() => {
  stopScrollDepth?.();
});
</script>

<template>
  <a class="skip-link" href="#main">דלג לתוכן הראשי</a>
  <router-view />
</template>
